import { render, staticRenderFns } from "./DifficultyMark.vue?vue&type=template&id=460951a5&scoped=true&"
import script from "./DifficultyMark.vue?vue&type=script&lang=ts&"
export * from "./DifficultyMark.vue?vue&type=script&lang=ts&"
import style0 from "./DifficultyMark.vue?vue&type=style&index=0&id=460951a5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460951a5",
  null
  
)

export default component.exports